<template>
  <generic-content
      :isLinkable="false"
      :isEditable="isEditable"
      :isPayable="isPayable"
      :isDeletable="isDeletable"
      :isDownloadable="isDownloadable"
      :isViewable="isViewable"
      :is-selected="isSelected"
      @click="$emit('click')"
      @view="$emit('view')"
      @edit="$emit('edit')"
      @download="$emit('download')"
      @delete="$emit('delete')"
  >
    <template #iconContent>
      <b-avatar
          size="32"
          variant="light-primary"
          class="my-auto"
      >
        <icon
            :icon="iconPaymentType"
        />
      </b-avatar>
    </template>

    <template #bodyContent>
      <div class="d-flex justify-content-between">
        <h6 class="transaction-title text-truncate">
          {{ payment._paymentBeneficiaries.length ? payment._paymentBeneficiaries.join(', ') : '-' }}
        </h6>

        <b-badge
            pill
            :variant="statusColor"
            class="mb-50"
        >
          <small>{{ capitalize($t(status)) }}</small>
        </b-badge>
      </div>
      <div class="d-flex justify-content-between text-truncate">
        <small>
          <i>{{ payment.date | moment('L') }}</i>
        </small>
        <small
            :class="payment.amount <= 0?'text-success':'text-danger'"
        >{{ currency(payment.amount) }}
        </small>
      </div>
    </template>

  </generic-content>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { capitalize, currency } from '../../../utils/filter'

import GenericContent from './Content'
import i18n from '@/libs/i18n'

export default {
  components: {
    GenericContent
  },
  props: {
    payment: {
      type: Object,
      default: () => {}
    },
    isDownloadable: {
      type: Boolean,
      default: true
    },
    isViewable: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isPayable: {
      type: Boolean,
      default: false
    },
    isDeletable: {
      type: Boolean,
      default: true
    },
    isParentMethodPriority: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const iconPaymentType = computed(() => {
      if (
          props.payment.paymentMethod.name == 'Bank transfert' ||
          props.payment.paymentMethod.name == i18n.t('Bank transfert')
      ) {
        return 'exchange-alt'
      } else if (props.payment.paymentMethod.name == 'Direct debit' ||
          props.payment.paymentMethod.name == i18n.t('Direct debit')) {
        return 'sign-out-alt'
      } else if (props.payment.paymentMethod.name == 'Debit card' ||
          props.payment.paymentMethod.name == i18n.t('Debit card')) {
        return 'credit-card'
      } else if (props.payment.paymentMethod.name == 'Check' ||
          props.payment.paymentMethod.name == i18n.t('Check')) {
        return 'money-check'
      } else if (props.payment.paymentMethod.name == 'Cash' ||
          props.payment.paymentMethod.name == i18n.t('Cash')) {
        return 'money-bill-wave'
      } else if (props.payment.paymentMethod.name == 'LCR' ||
          props.payment.paymentMethod.name == i18n.t('LCR')) {
        return 'file-invoice'
      } else if (props.payment.paymentMethod.name == 'Internal bank transfer' ||
          props.payment.paymentMethod.name == i18n.t('Internal bank transfer')) {
        return 'network-wired'
      } else {
        return 'euro-sign'
      }
    })

    const status = computed(() => {
      if (props.payment.bankTransaction != null) {
        if (
            parseFloat(props.payment.amount) !=
            parseFloat(props.payment.bankTransaction.debit ? props.payment.bankTransaction.debit : props.payment.bankTransaction.credit)) {
          return 'partialReconciliation'
        } else {
          return 'reconciliated'
        }
      } else {
        return 'unreconciliated'
      }
    })

    const statusColor = computed(() => {
      if (status.value == 'partialReconciliation') {
        return 'danger'
      } else if (status.value == 'reconciliated') {
        return 'success'
      } else if (status.value == 'unreconciliated') {
        return 'warning'
      }
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      currency,
      capitalize,

      // Data

      // Computed
      iconPaymentType,
      status,
      statusColor,

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {

  },
  created () {
  }
}
</script>

<style lang="scss">

</style>